import { ComponentProps, Dispatch, SetStateAction } from "react";
import * as S from "./styles";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { Button } from "../Button";
import { RolesEnum } from "../../../enums/roles";
import { MyModal } from "../MyModal";
import { IAgendamentoDTO } from "../../../types/agendamento";
import { Text } from "../Text";
import { useButtonOptions } from "./useButtonOptions";
import { IModalReembolsoProps } from "../../Molecules/FormScheduleDetail/useFormScheduleDetail";
import { RecursosEnum } from "../../../enums/recusos";
import { Agendamento } from "../../../services/Agendamento";
import { toast } from "react-toastify";

interface IButtonOptions extends ComponentProps<"details"> {
  disabled?: boolean;
  onCancel: () => void;
  handlePix: () => void;
  handleTicket: () => void;
  handleConfirmPayment: () => void;
  handleReturnStatus: () => void;
  agendamento: IAgendamentoDTO;
  handleConfirmRefund: Dispatch<SetStateAction<IModalReembolsoProps>>;
}

export const ButtonOptions = ({
  handlePix,
  handleConfirmPayment,
  handleReturnStatus,
  agendamento,
  handleConfirmRefund,
}: IButtonOptions) => {
  const {
    isIntern,
    isOpen,
    navigate,
    setISOpen,
    setIsLoad,
    sessionAgendamento,
    setSessionagendamento,
    handleCancel,
    usuario,
    recursos,
  } = useButtonOptions();

  const usuarioLogado = JSON.parse(
    localStorage.getItem("@usuarioMapa") || "{}"
  );

  const isUserOwnerOfFinishedAppointment =
    agendamento?.cliente?.uuidUsuario === usuarioLogado?.uuidUsuario &&
    agendamento?.status === StatusAgendamentoEnum?.FINALIZADO;

  function handleSatisfactionSurvey() {
    if (!agendamento?.uuid) return;

    setIsLoad(true);

    Agendamento.getUrlPesquisa(agendamento.uuid)
      .then(({ data }) => {
        const url = data;
        window.open(url, "_blank");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function onRescheduling() {
    setIsLoad(true);
    setSessionagendamento({
      ...sessionAgendamento,
      uuidAgendamento: agendamento?.uuid,
      reagendamento: true,
    });
    setTimeout(() => {
      agendamento?.itinerante
        ? navigate(`/agendamento/${agendamento.uuid}/itinerantes`)
        : isIntern
        ? navigate(`/novo-agendamento?id=${agendamento?.uuid}`)
        : navigate(`/agendamento/${agendamento.uuid}/loja?reagendamento=true`);

      setIsLoad(false);
    }, 1000);
  }

  return (
    <S.Container
      data-disabled={false}
      data-color-starcheck={process.env.REACT_APP_PROJECT === "starcheck"}
      data-color-log={process.env.REACT_APP_PROJECT === "log"}
      data-color-vlx={process.env.REACT_APP_PROJECT === "vlx"}
      data-color-tokyo={process.env.REACT_APP_PROJECT === "tokyo"}
    >
      <summary>
        <div>
          <span className="summary-title">ações</span>
        </div>
        <div className="summary-chevron-up">
          <img src="/assets/svgs/arrow-right.svg" alt="seta direita" />
        </div>
      </summary>

      <div
        className="summary-content"
        data-color-starcheck={process.env.REACT_APP_PROJECT === "starcheck"}
        data-color-log={process.env.REACT_APP_PROJECT === "log"}
        data-color-vlx={process.env.REACT_APP_PROJECT === "vlx"}
        data-color-tokyo={process.env.REACT_APP_PROJECT === "tokyo"}
      >
        {agendamento.status === StatusAgendamentoEnum.AGUARDANDO_PAGAMENTO &&
          (usuario?.roles?.includes(RolesEnum.ROLE_ADMIN) ||
            recursos?.includes(RecursosEnum.CONFIRMAR_PAGAMENTO)) && (
            <div>
              <div>
                <button onClick={handleConfirmPayment}>
                  Confirmar pagamento
                </button>
              </div>
            </div>
          )}

        {agendamento.status === StatusAgendamentoEnum.INICIADO &&
          (usuario?.roles?.includes(RolesEnum.ROLE_ADMIN) ||
            recursos?.includes(RecursosEnum.RETORNAR_STATUS)) && (
            <div>
              <div>
                <button onClick={handleReturnStatus}>Retornar status</button>
              </div>
            </div>
          )}

        {(agendamento.status === StatusAgendamentoEnum.AGENDADO ||
          (agendamento.status === StatusAgendamentoEnum.PAGO &&
            agendamento.itinerante != null)) && (
          <div>
            <div>
              <button onClick={onRescheduling}>Reagendar</button>
            </div>
          </div>
        )}

        <div>
          <div>
            <button onClick={() => setISOpen(true)}>Cancelar</button>
          </div>
        </div>

        {agendamento.status === StatusAgendamentoEnum.PAGO && (
          <div>
            <div>
              <button
                onClick={() =>
                  navigate(
                    `/agendamento/${agendamento?.uuid}/confirmar-horario`
                  )
                }
              >
                Realizar Agendamento
              </button>
            </div>
          </div>
        )}

        {agendamento.status === StatusAgendamentoEnum.AGUARDANDO_PAGAMENTO && (
          <>
            <div>
              <div>
                <button onClick={handlePix}>Ver fatura</button>
              </div>
            </div>
          </>
        )}

        {(sessionAgendamento?.roles?.includes(RolesEnum.ROLE_ADMIN) ||
          recursos?.includes("CONFIMAR_REEMBOLSO")) && (
          <div>
            <div>
              <button onClick={() => handleConfirmRefund({ isOPen: true })}>
                Confirmar Reembolso
              </button>
            </div>
          </div>
        )}

        <div>
          <div>
            <a
              href={`/assets/docs/checklist-${process.env.REACT_APP_PROJECT}.pdf`}
              download
            >
              Baixar Checklist
            </a>
          </div>
        </div>

        {isUserOwnerOfFinishedAppointment && (
          <div>
            <div>
              <button onClick={handleSatisfactionSurvey}>Avaliar</button>
            </div>
          </div>
        )}
      </div>

      <div className="summary-chevron-down">
        <S.ArrowDown src="/assets/svgs/arrow-right.svg" alt="seta direita" />
      </div>

      <MyModal isOpen={isOpen} onRequestClose={() => setISOpen(false)}>
        <S.ModalContent>
          <S.HeaderModal>
            <S.WrapperButtonClose>
              <button onClick={() => setISOpen(false)}>X</button>
            </S.WrapperButtonClose>

            <Text>
              Tem certeza que deseja{" "}
              <span className="textStrong">cancelar</span> sua vistoria?
            </Text>
          </S.HeaderModal>
          <S.WrapperText>
            <h4>Reembolso via PIX</h4>
            <p>
              Agendamentos pagos via <span>PIX</span> o reembolso acontecerá em{" "}
              <span>até 72h</span>.
            </p>

            <h4>Reembolso via Boleto</h4>
            <p>
              Agendamentos pagos via <span>Boleto</span> terão reembolso em{" "}
              <span>até 72h após compensação</span> com solicitação via
              preenchimento de formulário.
            </p>

            <S.WrapperButtonsModal>
              <button onClick={() => setISOpen(false)}>Cancelar</button>
              <Button onClick={() => handleCancel(agendamento)}>
                Confirmar
              </Button>
            </S.WrapperButtonsModal>
          </S.WrapperText>
        </S.ModalContent>
      </MyModal>
    </S.Container>
  );
};
